import { ReactNode } from 'react';

type StatusCellProps = {
  children: ReactNode;
};

export const StatusCell = ({ children }: StatusCellProps) => {
  return <td className="w-[42px] px-3 py-4">{children}</td>;
};
